import { render, staticRenderFns } from "./SelectSuggestBuyer.vue?vue&type=template&id=16ac71f4&scoped=true"
import script from "./SelectSuggestBuyer.vue?vue&type=script&lang=js"
export * from "./SelectSuggestBuyer.vue?vue&type=script&lang=js"
import style0 from "./SelectSuggestBuyer.vue?vue&type=style&index=0&id=16ac71f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac71f4",
  null
  
)

export default component.exports